import type { ServiceHandler } from "../bridge/message-router";

/** 生成 `plugin:{pluginId}:{key}`，避免与宿主或其它插件键冲突 */
function storageKey(pluginId: string, key: string): string {
  return `plugin:${pluginId}:${key}`;
}

/**
 * 存储服务：为插件提供按插件 id 隔离的 `localStorage` 读写；键形如 `plugin:{pluginId}:*`，值经 JSON 序列化。
 */
export const storageServiceHandler: ServiceHandler = async (pluginId, method, params) => {
  switch (method) {
    case "get": {
      /* 读取指定键，存在则 `JSON.parse` 后返回，否则 `null` */
      const { key } = params as { key: string };
      const raw = localStorage.getItem(storageKey(pluginId, key));
      return raw ? JSON.parse(raw) : null;
    }

    case "set": {
      /* 将任意可序列化值写入命名空间键 */
      const { key, value } = params as { key: string; value: unknown };
      localStorage.setItem(storageKey(pluginId, key), JSON.stringify(value));
      return;
    }

    case "remove": {
      /* 删除该插件命名空间下的单个键 */
      const { key } = params as { key: string };
      localStorage.removeItem(storageKey(pluginId, key));
      return;
    }

    default:
      throw Object.assign(new Error(`Unknown storage method: ${method}`), { code: "UNKNOWN_METHOD" });
  }
};
